// import Energia from './Index.vue'
import Permissions from "../../models/Permissions";

const Energia = () => import("./Index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

const meta = {
  requiresAuth: true,
  requiresCompany: true,
  showInMenu: true,
  label: "Energia",
  icon: "fa fa-bolt",
  group: "Arquivos",
  permissions,
};

export default [
  {
    path: "/energia",
    name: "Energia",
    component: Energia,
    meta,
  },
];
